import classNames from "classnames"
import { addHours, format, parse } from "date-fns"
import { Button } from "primereact/button"
import { Column } from "primereact/column"
import { DataTable } from "primereact/datatable"
import { Dropdown } from "primereact/dropdown"
import { InputText } from "primereact/inputtext"
import { useEffect, useRef, useState } from "react"
import { FaSearch, FaTimes } from "react-icons/fa"
import { toast } from "react-toastify"
import { mask, unMask } from "remask"
import AppCard from "../../../components/appCard"
import { NegotiationDetail } from "../../../components/dashboard/inadimplencias/listagem/detalhes"
import { NegotiateDialog } from "../../../components/dashboard/negociar/negociarDialog"
import { Api } from "../../../services/api"
import { DropdownInputGroup, LargeTablePague } from "../../../styles/primeReactConfig"
import formatDocument, { formatCurrency } from "../../../utils/formatCurrency"

function NegotiateProvider() {
  const [devedores, setDevedores] = useState([]);
  const [devedorSelecionado, setDevedorSelecionado] = useState([]);
  const [mostrarDivida, setMostrarDivida] = useState(false);
  const [showDetail, setShowDetail] = useState(false);
  const [filtro, setFiltro] = useState('todos');
  const [parametroFiltro, setParametroFiltro] = useState();
  const [opcoesFiltro] = useState([
    { label: "Todos", value: 'todos' },
    { label: "Documento", value: "documento" },
    { label: "Nome", value: "nome" },
  ]);
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [rowsPerPageOptions] = useState([10, 20, 50]);
  const [first, setFirst] = useState(0);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [reload, setReload] = useState(false);

  const [logInfo, setLogInfo] = useState([]);
  const [filtroSelecionadoLog, setFiltroSelecionadoLog] = useState("documento")
  const [filtroParametroLog, setFiltroParametroLog] = useState("")
  const [loadLog, setLoadLog] = useState(false);
  const opcoesFiltroLog = [
    { label: "Data Geração", value: "data" },
    { label: "Documento", value: "documento" },
    //{ label: "Nome Associado", value: "associado_nome" },
  ];
  const [reloadLog, setReloadLog] = useState(false)
  const [countLog, setCountLog] = useState(0)
  const searchState = useRef(false);
  const rowsLog = useRef(10);
  const firstLog = useRef(0);
  const pageLog = useRef(0);
  const rowCurrent = useRef([])

  const devedoresHeader = (
    <div className="justify-between grid md:flex items-center">
      <div>
        <h4>Selecione o Devedor</h4>
      </div>
      <div>
        <div className="grid md:flex md:h-12">
          <div className="flex">
            <Dropdown
              value={filtro}
              options={opcoesFiltro}
              pt={DropdownInputGroup}
              onChange={(e) => {
                setFiltro(e.value);
                setParametroFiltro(null);
              }}
            />
          </div>

          {filtro === "documento" &&
            <InputText
              value={parametroFiltro}
              onChange={(e) => setParametroFiltro(mask(unMask(e.target.value), ["999.999.999-99", "99.999.999/9999-99"]))}
              onKeyDown={(e) => e.code === 'Enter' && setReload(prevReload => !prevReload)}
              placeholder="Busca por CPF/CNPJ"
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'm-0 w-full md:w-auto',
                    'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                    {
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                        !context.disabled,
                      'hover:border-blue-500': !props.invalid && !context.disabled,
                      'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                      'border-gray-300 dark:border-blue-900/40': !props.invalid,
                      'border-red-500 hover:border-red-500/80 focus:border-red-500':
                        props.invalid && !context.disabled,
                      'border-red-500/50': props.invalid && context.disabled,
                    },
                    {
                      'text-lg px-4 py-4': props.size === 'large',
                      'text-xs px-2 py-2': props.size === 'small',
                      'p-3 text-base': !props.size || typeof props.size === 'number'
                    },
                    {
                      'pl-8': context.iconPosition === 'left',
                      'pr-8': props.iconPosition === 'right'
                    }
                  ),
                }),
              }}
            />}
          {filtro === "nome" &&
            <InputText
              value={parametroFiltro}
              onChange={(e) => setParametroFiltro(e.target.value)}
              onKeyDown={(e) => e.code === 'Enter' && setReload(prevReload => !prevReload)}
              placeholder="Busca por Nome"
              pt={{
                root: ({ props, context }) => ({
                  className: classNames(
                    'm-0 w-full md:w-auto',
                    'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                    {
                      'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                        !context.disabled,
                      'hover:border-blue-500': !props.invalid && !context.disabled,
                      'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                      'border-gray-300 dark:border-blue-900/40': !props.invalid,
                      'border-red-500 hover:border-red-500/80 focus:border-red-500':
                        props.invalid && !context.disabled,
                      'border-red-500/50': props.invalid && context.disabled,
                    },
                    {
                      'text-lg px-4 py-4': props.size === 'large',
                      'text-xs px-2 py-2': props.size === 'small',
                      'p-3 text-base': !props.size || typeof props.size === 'number'
                    },
                    {
                      'pl-8': context.iconPosition === 'left',
                      'pr-8': props.iconPosition === 'right'
                    }
                  ),
                }),
              }}
            />}

          <div className="flex items-center">
            <Button
              icon={<FaSearch className="text-xl" />}
              pt={{
                root: `hover:dark:bg-green-500 hover:bg-green-600 
                    dark:bg-green-400 bg-green-500 
                    flex justify-center items-center
                    w-[3rem] h-[3rem] p-0
                    text-white dark:text-black transition duration-300
                `,
                label: "absolute",
              }}
              onClick={() => setReload(prevReload => !prevReload)}
              severity="success"
            />
            <Button
              icon={<FaTimes className="text-2xl" />}
              pt={{
                root: `hover:dark:bg-red-500 hover:bg-red-600 
                  dark:bg-red-400 bg-red-500 rounded-r-md
                                      flex justify-center items-center
                  w-[3rem] h-[3rem] p-0
                  text-white dark:text-black transition duration-300`,
                label: "absolute",
              }}
              // style={{width:'4em'}}
              onClick={() => {
                setFiltro('todos');
                setParametroFiltro();
                setPage(0);
                setReload((prevReload) => !prevReload);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const headerHistorico = (
    <div className="flex between">
      <div className='grid md:flex h-full md:h-12'>
        <div className="flex">
          <Dropdown
            value={filtroSelecionadoLog}
            options={opcoesFiltroLog}
            pt={DropdownInputGroup}
            onChange={(e) => {
              setFiltroSelecionadoLog(e.value);
              setFiltroParametroLog(null);
            }}
          ></Dropdown>
          {/* <i className="pi pi-search"></i> */}
        </div>
        {filtroSelecionadoLog === "documento" &&
          <InputText
            value={filtroParametroLog}
            onChange={(e) => setFiltroParametroLog(mask(unMask(e.target.value), ["999.999.999-99", "99.999.999/9999-99"]))}
            placeholder="Busca por CPF/CNPJ devedor"
            onKeyDown={(e) => handleSearch(e.keyCode)}
            pt={{
              root: ({ props, context }) => ({
                className: classNames(
                  'm-0 w-full md:w-auto',
                  'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                  {
                    'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                      !context.disabled,
                    'hover:border-blue-500': !props.invalid && !context.disabled,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                    'border-gray-300 dark:border-blue-900/40': !props.invalid,
                    'border-red-500 hover:border-red-500/80 focus:border-red-500':
                      props.invalid && !context.disabled,
                    'border-red-500/50': props.invalid && context.disabled,
                  },
                  {
                    'text-lg px-4 py-4': props.size === 'large',
                    'text-xs px-2 py-2': props.size === 'small',
                    'p-3 text-base': !props.size || typeof props.size === 'number'
                  },
                  {
                    'pl-8': context.iconPosition === 'left',
                    'pr-8': props.iconPosition === 'right'
                  }
                ),
              }),
            }}
          />}
        {filtroSelecionadoLog === "associado_nome" &&
          <InputText
            value={filtroParametroLog}
            onChange={(e) => setFiltroParametroLog(e.target.value)}
            placeholder="Busca por Nome do Associado Responsável"
            onKeyDown={(e) => handleSearch(e.keyCode)}
            pt={{
              root: ({ props, context }) => ({
                className: classNames(
                  'm-0 w-full md:w-auto',
                  'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                  {
                    'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                      !context.disabled,
                    'hover:border-blue-500': !props.invalid && !context.disabled,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                    'border-gray-300 dark:border-blue-900/40': !props.invalid,
                    'border-red-500 hover:border-red-500/80 focus:border-red-500':
                      props.invalid && !context.disabled,
                    'border-red-500/50': props.invalid && context.disabled,
                  },
                  {
                    'text-lg px-4 py-4': props.size === 'large',
                    'text-xs px-2 py-2': props.size === 'small',
                    'p-3 text-base': !props.size || typeof props.size === 'number'
                  },
                  {
                    'pl-8': context.iconPosition === 'left',
                    'pr-8': props.iconPosition === 'right'
                  }
                ),
              }),
            }}
          />}
        {filtroSelecionadoLog === "data" &&
          <InputText
            value={filtroParametroLog}
            onChange={(e) => setFiltroParametroLog(mask(unMask(e.target.value), "99/99/9999"))}
            placeholder="Busca por Data de Geração"
            onKeyDown={(e) => handleSearch(e.keyCode)}
            pt={{
              root: ({ props, context }) => ({
                className: classNames(
                  'm-0 w-full md:w-auto',
                  'font-sans text-gray-600 dark:text-white/80 bg-white dark:bg-gray-900 border transition-colors duration-200 appearance-none rounded-none',
                  {
                    'focus:outline-none focus:outline-offset-0 focus:shadow-[0_0_0_0.2rem_rgba(191,219,254,1)] dark:focus:shadow-[0_0_0_0.2rem_rgba(147,197,253,0.5)]':
                      !context.disabled,
                    'hover:border-blue-500': !props.invalid && !context.disabled,
                    'opacity-60 select-none pointer-events-none cursor-default': context.disabled,
                    'border-gray-300 dark:border-blue-900/40': !props.invalid,
                    'border-red-500 hover:border-red-500/80 focus:border-red-500':
                      props.invalid && !context.disabled,
                    'border-red-500/50': props.invalid && context.disabled,
                  },
                  {
                    'text-lg px-4 py-4': props.size === 'large',
                    'text-xs px-2 py-2': props.size === 'small',
                    'p-3 text-base': !props.size || typeof props.size === 'number'
                  },
                  {
                    'pl-8': context.iconPosition === 'left',
                    'pr-8': props.iconPosition === 'right'
                  }
                ),
              }),
            }}
          />}
        <div className="flex items-center md:h-12">
          <Button
            pt={{
              root: `hover:dark:bg-green-500 hover:bg-green-600 
                dark:bg-green-400 bg-green-500 
                flex justify-center items-center
                w-[3rem] h-[3rem] p-0
                text-white dark:text-black transition duration-300
                `,
              label: "absolute",
            }}
            icon={<FaSearch className="text-xl" />}
            onClick={() => handleSearch(13)}
          />
          <Button
            icon={<FaTimes className="text-2xl" />}
            pt={{
              root: `hover:dark:bg-red-500 hover:bg-red-600 
              dark:bg-red-400 bg-red-500 rounded-r-md
              flex justify-center items-center
              w-[3rem] h-[3rem] p-0
              text-white dark:text-black transition duration-300`,
              label: "absolute",
            }}
            // style={{width:'4em'}}
            onClick={() => {
              setFiltroParametroLog("");
              searchState.current = false
              setReloadLog(prevReload => !prevReload)
            }}
          />
        </div>
      </div>
    </div>
  )

  function handleSearch(e) {
    if (e === 13) {
      searchState.current = true;
      rowsLog.current = 10;
      pageLog.current = 0;
      setReloadLog(prevReload => !prevReload);
    }
  }

  function onPage(event) {
    const startIndex = parseInt(event.first);
    setLimit(event.rows);
    setPage(event.page);
    setFirst(startIndex);
    setReload((prevReload) => !prevReload);
  };


  function onPageLog(event) {
    firstLog.current = event.first;
    rowsLog.current = event.rows;
    pageLog.current = event.page;
    setReloadLog(prevReload => !prevReload)
  }

  useEffect(() => {
    const listaDevedores = async () => {
      try {
        setLoading(true)
        const query = filtro === 'todos' ? '' : `?filtro=${filtro}&parametro=${unMask(parametroFiltro)}`
        const { data } = await Api.get(`/users/listarDevedores/${limit}/${page}${query}`)
        setDevedores(data.devedores)
        setTotal(data.count)
        //toast.success('Consumidores encontrados!')
        // console.log(data)
      } catch (error) {
        console.log(error)
        if (!error.response)
          return toast.error("Erro de conexão")
        if (error.response.status === 403) {
          toast.warn("Nenhum devedor encontrado")
          return setDevedores([])
        }
        if (error.response.status === 500) {
          return toast.error('Erro interno de servidor')
        }
      } finally {
        setLoading(false)
      }
    }
    listaDevedores()
  }, [reload]);

  useEffect(() => {
    async function consultaLog() {
      try {
        setLoadLog(true)
        const { data } = await Api.get(`cobranca/log_negociacoes_credor/${rowsLog.current}/${pageLog.current}`)
        setLogInfo(data.log_cobrancas)
        setCountLog(data.count)
      } catch (error) {
        console.log(error)
      } finally {
        setLoadLog(false)
      }
    }
    async function consultaLogFiltro() {
      let parametroLog = unMask(filtroParametroLog)
      if (filtroSelecionadoLog === 'data')
        parametroLog = format(parse(filtroParametroLog, 'dd/MM/yyyy', new Date()), 'yyyy-MM-dd')
      try {
        setLoadLog(true)
        const { data } = await Api.get(`cobranca/log_negociacoes_credor/${rowsLog.current}/${pageLog.current}?filtro=${filtroSelecionadoLog}&parametro=${parametroLog}`)
        setLogInfo(data.log_cobrancas)
        setCountLog(data.count)
      } catch (error) {
        searchState.current = false
        if(!error.response)
          toast.error('Erro de conexão')
        if(error.response.status === 404)
          toast.warn('Nenhuma negociação encontrada')
      } finally {
        setLoadLog(false)
      }
    }
    if (searchState.current)
      consultaLogFiltro()
    else
      consultaLog()
  }, [reloadLog])

  function toastController(type, message) {
    toast(message, { type: type });
  }

  return (
    <div>

      {mostrarDivida && <NegotiateDialog
        close={() => setMostrarDivida(false)} rowInfo={devedorSelecionado}
        refresh={() => { setReload(prevReload => !prevReload) }}
      />}
      {showDetail && <NegotiationDetail rowInfo={rowCurrent.current} close={() => setShowDetail(false)} toast={toastController} />}
      <AppCard className="">
        <h4 className="text-xl"><b>Negociar Dívida</b></h4>
        <DataTable
          value={devedores}
          header={devedoresHeader}
          paginator
          first={first}
          rows={limit}
          onSelectionChange={(e) => { setDevedorSelecionado(e.value); setMostrarDivida(true) }}
          selection
          selectionMode="single"
          pt={LargeTablePague}
          rowsPerPageOptions={rowsPerPageOptions}
          totalRecords={total}
          onPage={onPage}
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
          lazy
          loading={loading}
        >
          <Column field='usuario_nome' header="Nome" />
          <Column field='usuario_documento' header="Documento" body={rowData => formatDocument(rowData.usuario_documento)} />
          <Column field='usuario_telefone' header="Contato" body={rowData => rowData.usuario_telefone ? mask(rowData.usuario_telefone, ['(99) 9999-9999', '(99) 99999-9999']) : '-'} />
        </DataTable>
      </AppCard>
      <AppCard className="mt-4">
        <h4 className="text-xl"><b>Histórico de negociações geradas</b></h4>
        <div className=''>
          <DataTable
            filterDisplay='menu'
            header={headerHistorico}
            value={logInfo}
            rows={rowsLog.current}
            currentPageReportTemplate="Exibindo {first} de {last} do total de {totalRecords}"
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            rowsPerPageOptions={[10, 20, 50]}
            onPage={onPageLog}
            first={firstLog.current}
            selection
            onSelectionChange={(e) => { rowCurrent.current = e.value; setShowDetail(true) }}
            selectionMode="single"
            pt={LargeTablePague}
            totalRecords={countLog}
            emptyMessage="Nenhuma cobrança adicionada manualmente desde 18/04/2024"
            paginator
            lazy
            loading={loadLog}
          >
            <Column header='Usuário' field='associado_nome' body={(e) => { return e.associado_nome ? e.associado_nome : 'Acesso cliente' }} />
            <Column header='Data Geração' field='cobranca_create' body={(e) => { return format(new Date(e.cobranca_create), 'dd/MM/yyyy HH:mm:ss') }} />
            <Column header='Devedor Documento' field='ls_othervalue' body={(e) => { return formatDocument(e.ls_othervalue) }} />
            <Column field="cobranca_descricao" header="Descrição"></Column>
            <Column field="valor_total" header="Valor Total" body={(e) => formatCurrency(e.valor_total)}></Column>
            <Column field="cobranca_qtd_meio_pagamento" header="Nº Parcelas"></Column>
            <Column field="data_vencimento_primeiro_boleto" header="Vencimento 1º Boleto" body={(rowData) => rowData.data_vencimento_primeiro_boleto && format(addHours(new Date(rowData.data_vencimento_primeiro_boleto), 3), 'dd/MM/yyyy')} />
          </DataTable>
        </div>
      </AppCard>
    </div>
  )
}

export default NegotiateProvider